<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="发送总览" name="total-view">
        <div class="total-stats">
          <template>
            <el-row>
              <el-input v-model="sentStatsKeywords" placeholder="请输入任务名称" clearable
                style="width: 300px; margin-right: 10px;" @clear="getSendStats()"></el-input>
              <el-button @click="sentStatsCurrentPage = 1; getSendStats()" icon="el-icon-search" circle
                title="查询"></el-button>
              <el-button @click="showExportSendStats()" icon="el-icon-s-operation" circle title="筛选"></el-button>
            </el-row>
            <br>
            <el-table :data="sentStats" border style="width: 100%" height="650" v-loading="sentStatsLoading">
              <el-table-column prop="task_name" label="任务" width="240"></el-table-column>
              <el-table-column prop="sent_from" label="发件邮箱" width="240">
                <template v-slot="scope">
                  <span v-if="scope.row.send_mode == '普通模式'">{{ scope.row.sent_from }}</span>
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '切割模式'">
                    <div slot="content" v-html="concatenatedSentFrom(scope.row)"></div>
                    <el-link type="primary"><b style="color: #F56C6C;">切割</b> 查看发件邮箱</el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                    <div slot="content" v-html="concatenatedTurnModeSenders(scope.row)"></div>
                    <el-link type="primary"><b style="color: #F56C6C;">轮换</b> 查看发件邮箱</el-link>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="发送">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                    <div slot="content" v-html="concatenatedTurnModeSent(scope.row)"></div>
                    <el-link type="primary">查看</el-link>
                  </el-tooltip>
                  <span v-else>{{ scope.row.sent }}</span>
                </template>
              </el-table-column>
              <el-table-column label="已读">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                    <div slot="content" v-html="concatenatedTurnModeRead(scope.row)"></div>
                    <el-link type="primary">查看</el-link>
                  </el-tooltip>
                  <span v-else>{{ scope.row.read }}</span>
                </template>
              </el-table-column>
              <el-table-column label="未读">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                    <div slot="content" v-html="concatenatedTurnModeUnRead(scope.row)"></div>
                    <el-link type="primary">查看</el-link>
                  </el-tooltip>
                  <span v-else>{{ scope.row.unread }}</span>
                </template>
              </el-table-column>
              <el-table-column label="已读率">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                    <div slot="content" v-html="concatenatedTurnModeReadPercentage(scope.row)"></div>
                    <el-link type="primary">查看</el-link>
                  </el-tooltip>
                  <span v-else>{{ scope.row.read_percentage }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="创建时间" sortable></el-table-column>
              <el-table-column prop="creator" label="创建人" width="120"></el-table-column>
              <el-table-column label="操作" width="150">
                <template v-slot="scope">
                  <el-button icon="el-icon-view" @click="setTaskDetailRow(scope.row)" circle title="明细"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="sentStatsTotal"
            @size-change="changeSentStatsSize" @current-change="CurrentSentStatsChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="sentStatsSize">
          </el-pagination>
        </div>
        <el-dialog :title="viewTaskDetailName" :visible.sync="viewTaskDetailVisible" width="50%">
          <el-form :model="viewTaskDetailForm" label-width="60px">
            <el-row>
              <el-col :span="10" v-if="isTurnMode">
                <el-form-item label="执行轮" prop="letter_id">
                  <el-select v-model="viewTaskDetailForm.roundOption" placeholder="请选择"
                    @change="setTaskDetailRoundOption($event)">
                    <el-option v-for="item in viewTaskDetailRoundOptions" :key="item.key" :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="状态" prop="letter_id">
                  <el-select v-model="viewTaskDetailForm.option" placeholder="请选择"
                    @change="setTaskDetailOption($event)">
                    <el-option v-for="item in viewTaskDetailOptions" :key="item.key" :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-button type="primary" @click="viewTaskDetailSaveAs()">另存为</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="viewTaskDetailData" height="50vh" v-loading="sentStatsDetailLoading">
            <el-table-column prop="email" label="Email">
            </el-table-column>
            <el-table-column prop="receiver" label="Receiver">
            </el-table-column>
            <el-table-column prop="company" label="Company">
            </el-table-column>
          </el-table>
        </el-dialog>
        <el-dialog title="筛选" :visible.sync="exportSendStatsVisible" width="50%" style="margin-top: -120px;">
          <el-form :model="exportSendStatsForm" label-width="60px" v-loading="exportSendStatsLoading"
            element-loading-text="正在计算, 请稍候">
            <el-row>
              <el-col :span="24">
                <el-form-item label="时间跨度" prop="dates" label-width="80px">
                  <el-date-picker v-model="exportSendStatsForm.dates" type="datetimerange"
                    :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="人员" prop="user" label-width="80px">
                  <el-select v-model="exportSendStatsForm.user" filterable multiple clearable placeholder="请选择"
                    v-loading="sLoading">
                    <el-option v-for="item in users" :key="item.id" :label="item.name_cn" :value="item.id">
                    </el-option>
                  </el-select>
                  <template v-if="exportSendStatsForm.user.length < 1">
                    <i class="el-icon-warning-outline"></i>
                    <i>不选代表全部</i>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-row>
                  <el-form-item label="关键词" prop="product" label-width="80px">
                    <el-input v-model="exportSendStatsForm.product" placeholder="多个词以|隔开" clearable
                      style="width: 400px;"></el-input>
                    <el-button type="primary" @click="exportSendStats()" style="margin-left: 10px;">查 询</el-button>
                  </el-form-item>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <table border="1" style="border-collapse: collapse; width: 100%;">
              <tr v-for="(row, rowIndex) in screenSentData" :key="rowIndex" v-if="rowIndex === 0">
                <td v-for=" (value, key) in row" :key="key" v-if="key === 0" colspan="2">{{ value }}</td>
                <td v-for=" (value, key) in row" :key="key" v-if="key > 1" colspan="4">{{ value }}</td>
              </tr>
              <tr v-for="(row, rowIndex) in screenSentData" :key="rowIndex" v-if="rowIndex > 0">
                <td v-for=" (value, key) in row" :key="key">{{ value ? (value.length > 24 ? (value.substring(0, 24) +
                  '...') : value) : '' }}</td>
              </tr>
            </table>
          </template>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSendStats()" v-if="screenSentData.length > 0"
              :loading="save_btn_loading" :disabled="save_btn_disabled">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="发送任务" name="task">
        <el-row>
          <el-input v-model="taskListKeywords" placeholder="" clearable style="width: 300px; margin-right: 10px;"
            @clear="taskQueryList()"></el-input>
          <el-button @click="taskListCurrentPage = 1; taskQueryList()" icon="el-icon-search" circle
            title="搜索"></el-button>
          <el-button @click="addTask()" icon="el-icon-plus" circle title="新建"></el-button>
          <el-button type="success" @click="recycleBin('task')" icon="el-icon-delete" circle title="回收站"></el-button>
        </el-row>
        <br>
        <el-table :data="taskList" height="650" style="width: 100%" v-loading="vLoading">
          <el-table-column prop="task_name" label="任务名称" width="150">
          </el-table-column>
          <el-table-column prop="letter_file_name" label="开发信">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.letter_file_name" placement="top">
                <span>{{ scope.row.letter_file_name ? scope.row.letter_file_name.substring(0, 12) : '' }} ...</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="receivers_file_name" label="收件人列表">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.receivers_file_name" placement="top">
                <span>{{ scope.row.receivers_file_name ? scope.row.receivers_file_name.substring(0, 12) : '' }}
                  ...</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sender_username" label="发件箱">
            <template v-slot="scope">
              <span v-if="scope.row.send_mode == '普通模式'">{{ scope.row.sender_username }}</span>
              <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '切割模式'">
                <div slot="content" v-html="concatenatedSenders(scope.row)"></div>
                <el-link type="primary">查看发件邮箱</el-link>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                <div slot="content" v-html="concatenatedTurnModeSenders(scope.row)"></div>
                <el-link type="primary">查看发件邮箱</el-link>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="delay" label="是否延期" width="80">
            <template v-slot="scope">
              <i :class="scope.row.delay ? 'el-icon-check' : 'el-icon-close'"
                v-if="scope.row.send_mode == '普通模式' || scope.row.send_mode == '轮换模式'"></i>
              <i class="el-icon-timer" v-if="scope.row.send_mode == '切割模式'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="start_time" label="计划时间">
            <template v-slot="scope">
              <span>{{ scope.row.send_mode == '普通模式' || scope.row.send_mode == '轮换模式' ? (scope.row.delay ?
                scope.row.start_time : '即时') :
                ('切割 / 密度(' + scope.row.cut_density) + ')' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="send_interval" label="发送间隔" width="80">
            <template v-slot="scope">
              {{ scope.row.send_mode === '普通模式' || scope.row.send_mode === '轮换模式' ? scope.row.send_interval : '-' }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="状态" width="80">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dedede"
                @change="taskToggleStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column prop="creator" label="创建人" width="80">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column prop="percentage" label="发送进度">
            <template v-slot="scope">

              <el-tooltip class="item" effect="dark" placement="right" v-if="scope.row.send_mode == '轮换模式'">
                <div slot="content" v-html="concatenatedTurnModeProgress(scope.row)"></div>
                <el-link type="primary"><b style="color: #F56C6C;">轮换</b> 查看进度</el-link>
              </el-tooltip>
              <span v-if="scope.row.send_mode == '普通模式' || scope.row.send_mode == '切割模式'">{{ scope.row.percentage
                }}</span>
              &nbsp;
              <el-tooltip class="item" effect="dark" placement="left" v-if="scope.row.errors.length > 0">
                <div slot="content" v-html="concatenatedErrors(scope.row)"></div>
                <el-link type="warning">查看失败邮箱</el-link>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="danger" icon="el-icon-delete" @click="taskDel(scope.row)" circle title="删除"></el-button>
              <el-button type="primary" icon="el-icon-more" @click="taskView(scope.row)" circle title="更多"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="taskListTotal"
            @size-change="changeTaskListSize" @current-change="CurrentTaskListChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="taskListSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务" :visible.sync="addTaskVisable" v-loading="loading" element-loading-text="正在保存, 请稍候"
          style="margin-top: -80px;">
          <el-form :model="taskForm" label-width="120px" :rules="taskRules" ref="taskForm">
            <el-row>
              <el-col :span="20">
                <el-form-item label="任务名称" prop="task_name">
                  <el-input v-model="taskForm.task_name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="开发信" prop="letter_id">
                  <el-select v-model="taskForm.letter_id" placeholder="请选择" filterable>
                    <el-option v-for="item in lettersOptions" :key="item.id" :label="item.file_name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="收件人" prop="receivers_id">
                  <el-select v-model="taskForm.receivers_id" placeholder="请选择" filterable
                    @change="receiversSelected($event)">
                    <el-option v-for="item in receiversOptions" :key="item.id" :label="item.file_name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收件人总数">
                  <span class="current_receiver_count">{{ current_receiver_count }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="实显发件箱">
                  <el-input v-model="taskForm.from_address" placeholder="如果为空, 则与发件箱一致"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="实显发件人" prop="from_name">
                  <el-input v-model="taskForm.from_name" placeholder="Alchemist"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="发送模式" prop="send_mode">
                  <el-select v-model="taskForm.send_mode">
                    <el-option key="0" label="普通模式" value="普通模式"></el-option>
                    <el-option key="1" label="切割模式" value="切割模式"></el-option>
                    <el-option key="2" label="轮换模式" value="轮换模式"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label-width="0" prop="mixed">
                  <el-checkbox v-model="taskForm.mixed">混合内容 <i class="el-icon-question"
                      title="混合入非常规邮件内容(不可见)"></i></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-if="taskForm.send_mode == '普通模式'">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="发送间隔(秒)" prop="send_interval">
                    <el-input v-model.number="taskForm.send_interval" type="number" min="10"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="发件箱" prop="sender_id">
                    <el-select v-model="taskForm.sender_id" placeholder="请选择" filterable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="是否延期">
                    <el-switch v-model="taskForm.delay" active-text="延期" inactive-text="立即"
                      @change="taskDelayToggleStatus(taskForm.delay)">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="taskStartTimeVisable">
                <el-col :span="20">
                  <el-form-item label="计划时间">
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="taskForm.start_time"
                      style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="taskForm.send_mode == '切割模式'">
              <el-row>
                <el-col :span="20">
                  <el-form-item label="发件箱" prop="multi_sender_id">
                    <el-select v-model="taskForm.multi_sender_id" placeholder="请选择" filterable multiple clearable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="切割密度(单次)" prop="cut_density">
                    <el-input v-model.number="taskForm.cut_density" type="number" min="1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="切割模式" prop="cut_mode">
                    <el-radio-group v-model="taskForm.cut_mode">
                      <el-radio-button label="顺序"></el-radio-button>
                      <el-radio-button label="随机"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="taskForm.send_mode == '轮换模式'">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="发送间隔(秒)" prop="send_interval">
                    <el-input v-model.number="taskForm.send_interval" type="number" min="10"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="执行轮数" prop="send_rounds">
                    <el-select v-model="send_rounds">
                      <el-option :key="v" :label="v" :value="v" v-for="(v) in 10"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="每轮间隔(h)" prop="round_space">
                    <el-select v-model="taskForm.round_space">
                      <el-option key="24" label="24" value="24"></el-option>
                      <el-option key="48" label="48" value="48"></el-option>
                      <el-option key="72" label="72" value="72"></el-option>
                      <el-option key="96" label="96" value="96"></el-option>
                      <el-option key="120" label="120" value="120"></el-option>
                      <el-option key="144" label="144" value="144"></el-option>
                      <el-option key="168" label="168" value="168"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="9" v-for="(round, index) in send_rounds" :key="index">
                  <el-form-item :label="'第' + (index + 1) + '轮'" :prop="'rest_senders' + (index + 1)">
                    <el-select v-model="rest_senders[index + 1]" placeholder="请选择" filterable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="首轮开始">
                    <el-switch v-model="taskForm.delay" active-text="延期" inactive-text="立即"
                      @change="taskDelayToggleStatus(taskForm.delay)">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="taskStartTimeVisable">
                <el-col :span="20">
                  <el-form-item label="计划时间">
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="taskForm.start_time"
                      style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddTask()">取 消</el-button>
            <el-button type="primary" @click="confirmAddTask()">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="查看任务" :visible.sync="detailTaskVisable" style="margin-top: -80px;">
          <el-form :model="detailTaskForm" label-width="120px" :rules="taskRules" ref="detailTaskForm"
            v-loading="detailLoading" :element-loading-text="detailTaskLoadingText">
            <el-row>
              <el-col :span="20">
                <el-form-item label="任务名称" prop="task_name">
                  <el-input v-model="detailTaskForm.task_name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="开发信" prop="letter_id">
                  <el-select v-model="detailTaskForm.letter_id" placeholder="请选择" filterable>
                    <el-option v-for="item in lettersOptions" :key="item.id" :label="item.file_name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="收件人" prop="receivers_id">
                  <el-select v-model="detailTaskForm.receivers_id" placeholder="请选择" filterable
                    @change="receiversSelected($event)">
                    <el-option v-for="item in receiversOptions" :key="item.id" :label="item.file_name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收件人总数">
                  <span class="current_receiver_count">{{ current_receiver_count }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="实显发件箱">
                  <el-input v-model="detailTaskForm.from_address" placeholder="如果为空, 则与发件箱一致"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="实显发件人" prop="from_name">
                  <el-input v-model="detailTaskForm.from_name" placeholder="Alchemist"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="发送模式" prop="send_mode">
                  <el-select v-model="detailTaskForm.send_mode">
                    <el-option key="0" label="普通模式" value="普通模式"></el-option>
                    <el-option key="1" label="切割模式" value="切割模式"></el-option>
                    <el-option key="2" label="轮换模式" value="轮换模式"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label-width="0" prop="mixed">
                  <el-checkbox v-model="detailTaskForm.mixed">混合内容 <i class="el-icon-question"
                      title="混合入非常规邮件内容(不可见)"></i></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-if="detailTaskForm.send_mode == '普通模式'">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="发送间隔(秒)" prop="send_interval">
                    <el-input v-model.number="detailTaskForm.send_interval" type="number" min="10"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="发件箱" prop="sender_id">
                    <el-select v-model="detailTaskForm.sender_id" placeholder="请选择" filterable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="是否延期">
                    <el-switch v-model="detailTaskForm.delay" active-text="延期" inactive-text="立即"
                      @change="taskDelayToggleStatus(detailTaskForm.delay)">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="detailTaskStartTimeVisable">
                <el-col :span="20">
                  <el-form-item label="计划时间">
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="detailTaskForm.start_time"
                      style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="detailTaskForm.send_mode == '切割模式'">
              <el-row>
                <el-col :span="20">
                  <el-form-item label="发件箱" prop="multi_sender_id">
                    <el-select v-model="detailTaskForm.multi_sender_id" placeholder="请选择" filterable multiple clearable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="切割密度(单次)" prop="cut_density">
                    <el-input v-model.number="detailTaskForm.cut_density" type="number" min="1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="切割模式" prop="cut_mode">
                    <el-radio-group v-model="detailTaskForm.cut_mode">
                      <el-radio-button label="顺序"></el-radio-button>
                      <el-radio-button label="随机"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="detailTaskForm.send_mode == '轮换模式'">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="发送间隔(秒)" prop="send_interval">
                    <el-input v-model.number="detailTaskForm.send_interval" type="number" min="10"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="执行轮数" prop="send_rounds">
                    <el-select v-model="send_rounds">
                      <el-option :key="v" :label="v" :value="v" v-for="(v) in 10"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="每轮间隔(h)" prop="round_space">
                    <el-select v-model="detailTaskForm.round_space">
                      <el-option key="24" label="24" value="24"></el-option>
                      <el-option key="48" label="48" value="48"></el-option>
                      <el-option key="72" label="72" value="72"></el-option>
                      <el-option key="96" label="96" value="96"></el-option>
                      <el-option key="120" label="120" value="120"></el-option>
                      <el-option key="144" label="144" value="144"></el-option>
                      <el-option key="168" label="168" value="168"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="9" v-for="(round, index) in send_rounds" :key="index">
                  <el-form-item :label="'第' + (index + 1) + '轮'" :prop="'rest_senders' + (index + 1)">
                    <el-select v-model="rest_senders[index + 1]" placeholder="请选择" filterable>
                      <el-option v-for="item in senderOptions" :key="item.id" :label="item.username" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item label="首轮开始">
                    <el-switch v-model="detailTaskForm.delay" active-text="延期" inactive-text="立即"
                      @change="taskDelayToggleStatus(detailTaskForm.delay)">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="detailTaskStartTimeVisable">
                <el-col :span="20">
                  <el-form-item label="计划时间">
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="detailTaskForm.start_time"
                      style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelEditTask()">关 闭</el-button>
            <el-button type="primary" @click="confirmEditTask()">修 改</el-button>
          </div>
        </el-dialog>
        <el-dialog title="回收站" :visible.sync="taskRecycleBin" width="70%">
          <el-table :data="taskRecycleBinData" height="550" v-loading="vLoading">
            <el-table-column prop="task_name" label="任务名称">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.task_name" placement="top">
                  <span>{{ scope.row.task_name ? scope.row.task_name.substring(0, 12) : '' }} ...</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="letter_name" label="开发信">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.letter_name" placement="top">
                  <span>{{ scope.row.letter_name ? scope.row.letter_name.substring(0, 12) : '' }} ...</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="receivers_name" label="收件人">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.receivers_name" placement="top">
                  <span>{{ scope.row.receivers_name ? scope.row.receivers_name.substring(0, 12) : '' }} ...</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="creator" label="创建人" width="100">
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" sortable width="170">
            </el-table-column>
            <el-table-column prop="" label="操作">
              <template v-slot="scope">
                <el-button type="success" icon="el-icon-refresh-left" @click="recycleRestore(scope.row, 'task')"
                  circle></el-button>
                <el-button type="danger" icon="el-icon-delete" @click="recycleDel(scope.row, 'task')"
                  circle></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagenation">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="taskRecycleTotal"
              @size-change="changeTaskRecycleSize" @current-change="currentTaskRecycleChange"
              :page-sizes="[10, 20, 50, 100]" :page-size="taskRecycleSize">
            </el-pagination>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="开发信列表" name="letters">
        <el-row>
          <el-input v-model="letterListKeywords" placeholder="" clearable style="width: 300px; margin-right: 10px;"
            @clear="developLettersList()"></el-input>
          <el-button @click="letterListCurrentPage = 1; developLettersList()" icon="el-icon-search" circle
            title="搜索"></el-button>
          <el-button @click="uploadExcelVisable = true" icon="el-icon-upload2" circle title="上传"></el-button>
        </el-row>
        <br>
        <el-table :data="lettersList" height="650" style="width: 100%" v-loading="vLoading">
          <el-table-column prop="file_name" label="文件名">
          </el-table-column>
          <el-table-column prop="country" label="国家">
          </el-table-column>
          <el-table-column prop="language" label="语种">
          </el-table-column>
          <el-table-column prop="upload_at" label="上传时间">
          </el-table-column>
          <el-table-column prop="upload_by" label="上传者">
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template v-slot="scope">
              <el-button type="primary" icon="el-icon-document" @click="preview(scope.row)" circle
                title="查看"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="del(scope.row)" circle title="删除"></el-button>
              <el-button type="success" icon="el-icon-download" @click="download(scope.row)" circle
                title="下载"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="letterListTotal"
            @size-change="changeLetterListSize" @current-change="CurrentLetterListChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="letterListSize">
          </el-pagination>
        </div>
        <el-dialog title="上传开发信模板" :visible.sync="uploadExcelVisable">
          <el-form :model="uploadExcelForm" label-width="120px">
            <el-form-item label="国家">
              <el-col :span="10">
                <el-select v-model="uploadExcelForm.country" filterable clearable placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in countries" :key="item.area_id" :label="item.name" :value="item.area_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="语种">
              <el-col :span="10">
                <el-input placeholder="请输入内容" v-model="uploadExcelForm.language"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="lettersFileList" accept=".xls,.xlsx"
                  :limit="1" :headers="headersObj" :on-success="lettersUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelLettersUpload">取 消</el-button>
            <el-button type="primary" @click="submitLettersPreview">预 览</el-button>
            <el-button type="primary" @click="saveLettersUpload">保 存</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="uploadExcelFileName" :visible.sync="excelPreviewVisible" width="90%">
          <el-table :data="uploadExcelData">
            <el-table-column property="0" width="40">
              <template slot-scope="scope">
                <div v-html="scope.row[0]"></div>
              </template>
            </el-table-column>
            <el-table-column property="1">
              <template slot-scope="scope">
                <div v-html="scope.row[1]"></div>
              </template>
            </el-table-column>
            <el-table-column property="2">
              <template slot-scope="scope">
                <div v-html="scope.row[2]"></div>
              </template>
            </el-table-column>
            <el-table-column property="3">
              <template slot-scope="scope">
                <div v-html="scope.row[3]"></div>
              </template>
            </el-table-column>
            <el-table-column property="4">
              <template slot-scope="scope">
                <div v-html="scope.row[4]"></div>
              </template>
            </el-table-column>
            <el-table-column property="5">
              <template slot-scope="scope">
                <div v-html="scope.row[5]"></div>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="excelPreviewVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="收件人列表" name="receivers">
        <el-row>
          <el-input v-model="receiversListKeywords" placeholder="" clearable style="width: 300px; margin-right: 10px;"
            @clear="receiversQueryList()"></el-input>
          <el-button @click="receiversListCurrentPage = 1; receiversQueryList()" icon="el-icon-search" circle
            title="搜索"></el-button>
          <el-button @click="uploadReceiversVisable = true" icon="el-icon-upload2" circle title="上传"></el-button>
        </el-row>
        <br>
        <el-table :data="receiversList" height="650" style="width: 100%" v-loading="vLoading">
          <el-table-column prop="file_name" label="文件名">
          </el-table-column>
          <el-table-column prop="country" label="国家">
          </el-table-column>
          <el-table-column prop="product" label="适用产品">
          </el-table-column>
          <el-table-column prop="upload_at" label="上传时间">
          </el-table-column>
          <el-table-column prop="upload_by" label="上传者">
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template v-slot="scope">
              <el-button type="primary" icon="el-icon-document" @click="receiversPreview(scope.row)" circle
                title="查看"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="receiversDel(scope.row)" circle
                title="删除"></el-button>
              <el-button type="success" icon="el-icon-download" @click="receiversDownload(scope.row)" circle
                title="下载"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="receiversListTotal"
            @size-change="changeReceiversListSize" @current-change="CurrentReceiversListChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="receiversListSize">
          </el-pagination>
        </div>
        <el-dialog title="上传收件人" :visible.sync="uploadReceiversVisable">
          <el-form :model="uploadReceiversForm" label-width="120px" :rules="uploadReceiversRules"
            ref="uploadReceiversForm">
            <el-form-item label="国家">
              <el-col :span="10">
                <el-select v-model="uploadReceiversForm.country" filterable clearable placeholder="请选择"
                  style="width: 100%">
                  <el-option v-for="item in countries" :key="item.area_id" :label="item.name" :value="item.area_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="适用产品" prop="product">
              <el-col :span="10">
                <el-input placeholder="与邮件主题关联" v-model="uploadReceiversForm.product"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="receiversFileList"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj" :on-success="receiversUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelReceiversUpload">取 消</el-button>
            <el-button type="primary" @click="submitReceiversPreview">预 览</el-button>
            <el-button type="primary" @click="saveReceiversUpload">保 存</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="uploadReceiversFileName" :visible.sync="receiversPreviewVisible" width="90%">
          <el-table :data="uploadReceiversData">
            <el-table-column property="0">
              <template slot-scope="scope">
                <div v-html="scope.row[0]"></div>
              </template>
            </el-table-column>
            <el-table-column property="1">
              <template slot-scope="scope">
                <div v-html="scope.row[1]"></div>
              </template>
            </el-table-column>
            <el-table-column property="2">
              <template slot-scope="scope">
                <div v-html="scope.row[2]"></div>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="receiversPreviewVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="发信箱管理" name="senders">
        <el-row>
          <el-input v-model="sendersListKeywords" placeholder="" style="width: 300px; margin-right: 10px;" clearable
            @clear="sendersQueryList()"></el-input>
          <el-button @click="sendersListCurrentPage = 1; sendersQueryList()" icon="el-icon-search" circle
            title="搜索"></el-button>
          <el-button @click="addSendersVisable = true" icon="el-icon-plus" circle title="新建"></el-button>
        </el-row>
        <br>
        <el-table :data="sendersList" height="650" style="width: 100%" v-loading="vLoading">
          <el-table-column prop="username" label="用户名">
          </el-table-column>
          <el-table-column prop="counts" label="今日发量">
          </el-table-column>
          <el-table-column prop="host" label="服务器">
          </el-table-column>
          <el-table-column prop="creator" label="创建人">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column prop="status" label="启用">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dedede"
                @change="sendersToggleStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template v-slot="scope">
              <el-button type="primary" icon="el-icon-edit-outline" @click="sendersEdit(scope.row)" circle
                title="编辑"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="sendersDel(scope.row)" circle
                title="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="sendersListTotal"
            @size-change="changeSendersListSize" @current-change="CurrentSendersListChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="sendersListSize">
          </el-pagination>
        </div>
        <el-dialog title="新增发件箱" :visible.sync="addSendersVisable" v-loading="loading" element-loading-text="正在保存, 请稍候">
          <el-form :model="sendersForm" label-width="100px" :rules="sendersRules" ref="`sendersForm`">
            <el-row>
              <el-col :span="10">
                <el-form-item label="信箱协议">
                  <el-select v-model="sendersForm.mailer" placeholder="请选择">
                    <el-option v-for="item in mailerOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="加密方式">
                  <el-input v-model="sendersForm.encryption" placeholder="默认留空"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="服务器" prop="host">
                  <el-input v-model="sendersForm.host" placeholder="mail或smtp.xxx.com"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="端口">
                  <el-input type="number" min="0" max="65535" v-model="sendersForm.port"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="sendersForm.username" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="sendersForm.password" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddSenders()">取 消</el-button>
            <el-button type="primary" @click="confirmAddSenders()" :loading="email_sender_loading">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="编辑发件箱" :visible.sync="editSendersVisable" v-loading="loading"
          element-loading-text="正在保存, 请稍候">
          <el-form :model="editSendersForm" label-width="100px" :rules="sendersRules" ref="editSendersForm">
            <el-row>
              <el-col :span="10">
                <el-form-item label="信箱协议">
                  <el-select v-model="editSendersForm.mailer" placeholder="请选择">
                    <el-option v-for="item in mailerOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="加密方式">
                  <el-input v-model="editSendersForm.encryption" placeholder="默认留空"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="服务器" prop="host">
                  <el-input v-model="editSendersForm.host"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="端口">
                  <el-input type="number" min="0" max="65535" v-model="editSendersForm.port"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="editSendersForm.username" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="editSendersForm.password" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelEditSenders()">取 消</el-button>
            <el-button type="primary" @click="confirmEditSenders()" :loading="email_sender_loading">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'Emails',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'total-view',
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      keywords: '',
      exportSendStatsVisible: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      exportSendStatsForm: {
        dates: null,
        user: [],
        product: ''
      },
      exportSendStatsLoading: false,
      save_btn_loading: false,
      save_btn_disabled: false,
      users: [],
      products: [],
      screenSentData: [],
      countries: [],
      uploadExcelVisable: false,
      uploadReceiversVisable: false,
      excelPreviewVisible: false,
      uploadExcelForm: {
        country: null,
        language: '英语'
      },
      lettersFileList: [],
      receiversFileList: [],
      uploadExcelFileName: '',
      uploadExcelData: [],
      lettersList: [],
      receiversList: [],
      uploadReceiversData: [],
      uploadReceiversForm: {
        country: null,
        product: null
      },
      uploadReceiversRules: {
        product: [
          { required: true, message: '产品不能为空', trigger: 'commit' }
        ]
      },
      receiversPreviewVisible: false,
      uploadReceiversFileName: '',
      repliersList: [],
      addRepliersVisable: false,
      repliersForm: {},
      sendersList: [],
      addSendersVisable: false,
      sendersForm: {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      },
      sendersRules: {
        host: [
          { required: true, message: '服务器不能为空', trigger: 'commit' }
        ],
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      },
      editSendersVisable: false,
      editSendersForm: {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      },
      mailerOptions: [
        {
          label: 'smtp',
          value: 'smtp'
        }
      ],
      loading: false,
      email_sender_loading: false,
      addTaskVisable: false,
      taskList: [],
      taskForm: {
        task_name: '',
        letter_id: '',
        receivers_id: '',
        sender_id: '',
        delay: false,
        start_time: '',
        from_address: '',
        from_name: '',
        send_interval: 30,
        send_mode: '普通模式',
        multi_sender_id: '',
        cut_density: 50,
        cut_mode: '顺序',
        round_space: '48',
        mixed: false
      },
      detailTaskForm: {},
      detailTaskVisable: false,
      detailLoading: false,
      detailTaskLoadingText: '请稍候',
      send_rounds: 4,
      current_receiver_count: '',
      lettersOptions: [],
      receiversOptions: [],
      senderOptions: [],
      taskStartTimeVisable: false,
      taskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ],
        from_name: [
          { required: true, message: '实显发件人不能为空', trigger: 'commit' }
        ],
        send_interval: [
          { required: true, message: '发送间隔不能为空', trigger: 'commit' },
          { type: 'number', min: 10, message: '不能低于10秒', trigger: 'change' }
        ]
      },
      sentStats: [],
      viewTaskDetailName: '',
      viewTaskDetailVisible: false,
      viewTaskDetailData: [],
      viewTaskDetailForm: {
        option: 'all',
        roundOption: 0
      },
      viewTaskDetailRow: {},
      viewTaskDetailOptions: [
        {
          key: 'all',
          value: '全部'
        },
        {
          key: 'read',
          value: '已读'
        },
        {
          key: 'unread',
          value: '未读'
        }
      ],
      viewTaskDetailRoundOptions: [],
      interval: '',
      sentStatsKeywords: '',
      sentStatsTotal: 0,
      sentStatsSize: 10,
      sentStatsCurrentPage: 1,
      taskListKeywords: '',
      taskListTotal: 0,
      taskListSize: 10,
      taskListCurrentPage: 1,
      letterListKeywords: '',
      letterListTotal: 0,
      letterListSize: 10,
      letterListCurrentPage: 1,
      receiversListKeywords: '',
      receiversListTotal: 0,
      receiversListSize: 10,
      receiversListCurrentPage: 1,
      sendersListKeywords: '',
      sendersListTotal: 0,
      sendersListSize: 10,
      sendersListCurrentPage: 1,
      taskRecycleBin: false,
      taskRecycleBinData: [],
      taskRecycleTotal: 0,
      taskRecycleSize: 10,
      taskRecycleCurrentPage: 1,
      rest_senders: {
        rest_senders1: ''
      },
      sentStatsLoading: false,
      sentStatsDetailLoading: false,
      isTurnMode: false,
      vLoading: false,
      sLoading: false
    }
  },
  mounted() {
    // 发送统计
    this.getSendStats()
    // 构建echarts
    // this.drawCharts()
    this.$axios.get('/basic/world_city_list', {
      params: {
        parent_id: 0
      }
    }).then((response) => {
      if (response.data.code === 200) {
        this.countries = response.data.data;
      }
    });
    this.intervals = setInterval(() => {
      if (this.activeName === 'total-view') {
        // this.getSendStats();
      } else if (this.activeName === 'task') {
        this.taskQueryList(true);
      }
    }, 30000);
  },
  computed: {
    combinedSenders() {
      const combinedSenders = {};
      for (let i = 1; i <= this.send_rounds; i++) {
        if (this.rest_senders[i] !== '' && this.rest_senders[i] !== undefined) {
          combinedSenders[i] = this.rest_senders[i];
        }
      }
      return combinedSenders;
    }
  },
  methods: {
    getSendStats() {
      this.sentStatsLoading = true
      this.$axios.get(`email/sent_stats`, {
        params: {
          keywords: this.sentStatsKeywords,
          size: this.sentStatsSize,
          page: this.sentStatsCurrentPage
        }
      }).then((response) => {
        this.sentStatsLoading = false;
        if (response.data.code === 200) {
          this.sentStats = response.data.data.data
          this.sentStatsTotal = response.data.data.total
        }
      });
    },
    changeSentStatsSize(val) {
      this.sentStatsSize = val;
      this.getSendStats();
    },
    CurrentSentStatsChange(val) {
      this.sentStatsCurrentPage = val;
      this.getSendStats();
    },
    setTaskDetailOption(event) {
      this.viewTaskDetailForm.option = event;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    setTaskDetailRoundOption(event) {
      this.viewTaskDetailForm.roundOption = event;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    setTaskDetailRow(row) {
      this.viewTaskDetailRoundOptions = [];
      if (row.send_mode === '轮换模式') {
        row.turn_mode_senders.forEach((value, key) => {
          this.viewTaskDetailRoundOptions.push({
            key: key,
            value: value
          })
        });
        this.isTurnMode = true
      } else {
        this.isTurnMode = false
      }
      this.viewTaskDetailRow = row;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    getTaskDetail() {
      this.sentStatsDetailLoading = true;
      this.viewTaskDetailName = this.viewTaskDetailRow.task_name
      this.viewTaskDetailVisible = true;
      let task_id = this.viewTaskDetailRow.task_id;
      let option = this.viewTaskDetailForm.option;
      let round = this.viewTaskDetailForm.roundOption;
      let send_mode = this.viewTaskDetailRow.send_mode;
      this.$axios.get(`email/task_detail?task_id=${task_id}&option=${option}&round=${round}&send_mode=${send_mode}`).then((response) => {
        this.sentStatsDetailLoading = false;
        if (response.data.code === 200) {
          this.viewTaskDetailData = response.data.data
        }
      });
    },
    viewTaskDetailSaveAs() {
      window.location.href = this.$axios.defaults.baseURL + 'email/task_detail_save_as?task_id=' + this.viewTaskDetailRow.task_id + '&option=' + this.viewTaskDetailForm.option + '&round=' + this.viewTaskDetailForm.roundOption + '&send_mode=' + this.viewTaskDetailRow.send_mode;
    },
    drawCharts() {
      let myChart1 = this.$echarts.init(document.getElementById('main1'))
      let option = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true
          }
        ]
      };
      myChart1.setOption(option)
    },
    tabClick(tab, event) {
      switch (tab.name) {
        case 'total-view':
          this.getSendStats();
          break;
        case 'task':
          this.taskQueryList();
          setTimeout(() => {
            this.initOptions();
          }, 0);
          break;
        case 'letters':
          this.developLettersList();
          break;
        case 'receivers':
          this.receiversQueryList();
          break;
        case 'repliers':
          this.repliersQueryList();
          break;
        case 'senders':
          this.sendersQueryList();
          break;
        case 'recycle':
          this.queryRecycleList();
          break;
      }
    },
    developLettersList: function () {
      this.vLoading = true;
      this.$axios.get('email/develop_letters/list', {
        params: {
          keywords: this.letterListKeywords,
          page: this.letterListCurrentPage,
          size: this.letterListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.lettersList = response.data.data.data;
          this.letterListTotal = response.data.data.total;
        }
      })
    },
    changeLetterListSize(val) {
      this.letterListSize = val;
      this.developLettersList();
    },
    CurrentLetterListChange(val) {
      this.letterListCurrentPage = val;
      this.developLettersList();
    },
    receiversQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/receivers/list', {
        params: {
          keywords: this.receiversListKeywords,
          page: this.receiversListCurrentPage,
          size: this.receiversListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.receiversList = response.data.data.data;
          this.receiversListTotal = response.data.data.total;
        }
      })
    },
    changeReceiversListSize(val) {
      this.receiversListSize = val;
      this.receiversQueryList();
    },
    CurrentReceiversListChange(val) {
      this.receiversListCurrentPage = val;
      this.receiversQueryList();
    },
    repliersQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/repliers/list', {
        params: {
          keywords: this.keywords
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.repliersList = response.data.data.data;
        }
      })
    },
    sendersQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/senders/list', {
        params: {
          keywords: this.sendersListKeywords,
          page: this.sendersListCurrentPage,
          size: this.sendersListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.sendersList = response.data.data.data;
          this.sendersListTotal = response.data.data.total;
        }
      })
    },
    changeSendersListSize(val) {
      this.sendersListSize = val;
      this.sendersQueryList();
    },
    CurrentSendersListChange(val) {
      this.sendersListCurrentPage = val;
      this.sendersQueryList();
    },
    taskQueryList: function (iv = false) {
      if (iv === false) {
        this.vLoading = true;
      }
      this.$axios.get('email/task/list', {
        params: {
          keywords: this.taskListKeywords,
          page: this.taskListCurrentPage,
          size: this.taskListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.taskList = response.data.data.data;
          this.taskListTotal = response.data.data.total;
        }
      })
    },
    changeTaskListSize(val) {
      this.taskListSize = val;
      this.taskQueryList();
    },
    CurrentTaskListChange(val) {
      this.taskListCurrentPage = val;
      this.taskQueryList();
    },
    lettersUploadSuccess: function (response) {
      this.lettersFileList = [];
      if (response.code === 200) {
        this.lettersFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelLettersUpload: function () {
      this.lettersFileList = [];
      this.uploadExcelVisable = false
    },
    receiversUploadSuccess: function (response) {
      this.receiversFileList = [];
      if (response.code === 200) {
        this.receiversFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelReceiversUpload: function () {
      this.receiversFileList = [];
      this.uploadReceiversVisable = false
    },
    submitLettersPreview: function () {
      let url = this.lettersFileList[0].url;
      this.$axios.get('excel/preview', {
        params: {
          url: url
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadExcelFileName = this.lettersFileList[0].name;
          this.uploadExcelData = response.data.data
          this.excelPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    submitReceiversPreview: function () {
      let url = this.receiversFileList[0].url;
      this.$axios.get('excel/preview', {
        params: {
          url: url
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadReceiversFileName = this.receiversFileList[0].name;
          this.uploadReceiversData = response.data.data
          this.receiversPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    saveLettersUpload: function () {
      this.$axios.post('email/develop_letters/save', {
        country: this.uploadExcelForm.country,
        language: this.uploadExcelForm.language,
        file_name: this.lettersFileList[0].name,
        file_path: this.lettersFileList[0].url
      }).then((response) => {
        if (response.data.code === 200) {
          this.uploadExcelVisable = false
          this.developLettersList();
        }
      })
    },
    saveReceiversUpload: function () {
      this.$refs.uploadReceiversForm.validate(valid => {
        if (valid) {
          this.$axios.post('email/receivers/save', {
            country: this.uploadReceiversForm.country,
            product: this.uploadReceiversForm.product,
            file_name: this.receiversFileList[0].name,
            file_path: this.receiversFileList[0].url
          }).then((response) => {
            if (response.data.code === 200) {
              this.uploadReceiversVisable = false
              this.receiversQueryList();
            }
          })
        }
      })
    },
    preview: function (row) {
      this.$axios.get('excel/preview', {
        params: {
          url: row.file_path
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadExcelFileName = row.file_name;
          this.uploadExcelData = response.data.data
          this.excelPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    receiversPreview: function (row) {
      this.$axios.get('excel/preview', {
        params: {
          url: row.file_path
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadReceiversFileName = row.file_name;
          this.uploadReceiversData = response.data.data
          this.receiversPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    del(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/develop_letters/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.developLettersList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    receiversDel(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/receivers/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.receiversQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    repliersDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/repliers/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.repliersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    download(row) {
      window.location.href = this.$axios.defaults.baseURL + 'email/develop_letters/download?id=' + row.id;
    },
    receiversDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'email/receivers/download?id=' + row.id;
    },
    cancelAddRepliers() {
      this.addRepliersVisable = false;
      this.repliersForm = {};
    },
    confirmAddRepliers() {
      this.$axios.post('email/repliers/add', this.repliersForm).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '添加成功',
            message: '添加成功',
            type: 'success'
          });
          this.addRepliersVisable = false;
          this.repliersForm = {};
          this.repliersQueryList();
        }
      })
    },
    repliersToggleStatus(row) {
      this.$notify({
        title: '提示',
        message: '修改状态不会影响已有的发送计划',
        type: 'info'
      })
      this.$axios.post('email/repliers/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        console.log(response);
      })
    },
    cancelAddSenders() {
      this.addSendersVisable = false;
      this.sendersForm = {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      }
    },
    confirmAddSenders() {
      this.email_sender_loading = true;
      // this.$refs.sendersForm.validate(valid => {
      //   if (valid) {

      //   }
      // })
      this.$axios.post('email/senders/add', this.sendersForm).then((response) => {
        if (response.data.code === 200) {
          this.addSendersVisable = false;
          this.sendersForm = {
            mailer: 'smtp',
            encryption: null,
            host: '',
            port: 25,
            username: '',
            password: ''
          }
          this.sendersQueryList();
        } else {
          this.$notify({
            title: '保存失败',
            message: response.data.data,
            type: 'error'
          })
        }
      })
      this.email_sender_loading = false;
    },
    sendersToggleStatus(row) {
      this.$axios.post('email/senders/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        this.$notify({
          title: '提示',
          message: '修改不会影响已有的发送计划',
          type: 'info'
        })
      })
    },
    sendersDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/senders/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.sendersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    sendersEdit(row) {
      this.editSendersVisable = true;
      this.$axios.get(`email/senders/detail?id=${row.id}`).then((response) => {
        if (response.data.code === 200) {
          this.editSendersForm = response.data.data
        }
      });
    },
    cancelEditSenders() {
      this.editSendersVisable = false;
      this.editSendersForm = {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      }
    },
    confirmEditSenders() {
      this.email_sender_loading = true;
      this.$refs.editSendersForm.validate(valid => {
        if (valid) {
          this.$axios.post('email/senders/save', this.editSendersForm).then((response) => {
            this.email_sender_loading = false;
            if (response.data.code === 200) {
              this.addSendersVisable = false;
              this.editSendersForm = {
                mailer: 'smtp',
                encryption: null,
                host: '',
                port: 25,
                username: '',
                password: ''
              }
              this.editSendersVisable = false;
              this.sendersQueryList();
            } else {
              this.$notify({
                title: '保存失败',
                message: response.data.data,
                type: 'error'
              })
            }
          })
          this.email_sender_loading = false;
        }
      })
    },
    addTask() {
      this.addTaskVisable = true;
    },
    initOptions() {
      this.$axios.get('email/task/options').then((response) => {
        if (response.data.code === 200) {
          this.lettersOptions = response.data.data.letters
          this.receiversOptions = response.data.data.receivers
          this.senderOptions = response.data.data.senders
        }
      })
    },
    taskDelayToggleStatus(delay) {
      this.taskStartTimeVisable = delay;
    },
    cancelAddTask() {
      this.addTaskVisable = false;
      this.taskForm = {
        task_name: '',
        letter_id: '',
        receivers_id: '',
        sender_id: '',
        delay: false,
        start_time: '',
        send_interval: 30,
        send_mode: '普通模式',
        multi_sender_id: '',
        cut_density: 50,
        cut_mode: '顺序',
        round_space: '48',
        mixed: false
      };
      this.current_receiver_count = ''
    },
    confirmAddTask() {
      let combined_senders = Object.values(this.combinedSenders);
      if (this.taskForm.send_mode === '轮换模式') {
        if (this.rest_senders[1] === '' || this.rest_senders[1] === undefined) {
          this.$message({
            title: '操作失败',
            message: '第1轮不能为空',
            type: 'error'
          })
          return false;
        }
        if (combined_senders.length < this.send_rounds) {
          this.$message({
            title: '操作失败',
            message: '总轮数和选择的邮箱数量不符',
            type: 'error'
          })
          return false;
        }
      }
      this.taskForm.combined_senders = combined_senders;
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$axios.post('email/task/add', this.taskForm).then((response) => {
            this.loading = false;
            if (response.data.code === 200) {
              this.$notify({
                title: '操作成功',
                message: '任务创建成功',
                type: 'success'
              })
              this.taskQueryList();
              this.addTaskVisable = false;
            }
          });
        }
      })
    },
    taskToggleStatus(row, index) {
      let notice = row.status ? '开启' : '停止';
      this.$confirm('确定' + notice + '任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/task/toggle_status', {
          id: row.id,
          status: row.status
        })
      }).catch(() => {
        this.taskList[index].status = !row.status;
      });
    },
    taskDel(row) {
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/task/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: response.data.data,
              type: 'success'
            })
          } else {
            this.$notify({
              title: '操作失败',
              message: response.data.data,
              type: 'error'
            })
          }
          this.taskQueryList();
        })
      })
    },
    taskView(row) {
      this.detailTaskForm = {};
      this.current_receiver_count = '';
      this.detailLoading = true;
      this.detailTaskLoadingText = '正在读取, 请稍候';
      this.detailTaskVisable = true;
      this.$axios.get(`email/task/detail?id=${row.id}`).then((response) => {
        this.detailLoading = false;
        if (response.data.code === 200) {
          let obj = response.data.data;
          this.detailTaskForm = obj
          this.send_rounds = obj.send_rounds;
          this.receiversSelected(obj.receivers_id);
          this.rest_senders = obj.rest_senders;
          this.detailTaskStartTimeVisable = obj.delay;
        }
      })
    },
    cancelEditTask() {
      this.detailTaskVisable = false;
      this.detailTaskForm = {};
      this.current_receiver_count = '';
    },
    confirmEditTask() {
      let combined_senders = Object.values(this.combinedSenders);
      if (this.detailTaskForm.send_mode === '轮换模式') {
        if (this.rest_senders[1] === '' || this.rest_senders[1] === undefined) {
          this.$message({
            title: '操作失败',
            message: '第1轮不能为空',
            type: 'error'
          })
          return false;
        }
        if (combined_senders.length < this.send_rounds) {
          this.$message({
            title: '操作失败',
            message: '总轮数和选择的邮箱数量不符',
            type: 'error'
          })
          return false;
        }
      }
      this.detailTaskForm.combined_senders = combined_senders;
      this.$refs.detailTaskForm.validate(valid => {
        if (valid) {
          this.detailLoading = true;
          this.detailTaskLoadingText = '正在保存, 请稍候';
          this.$axios.post('email/task/store', this.detailTaskForm).then((response) => {
            this.detailLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                title: '操作成功',
                message: '修改成功',
                type: 'success'
              })
              this.taskQueryList();
              this.detailTaskVisable = false;
            } else {
              this.$notify({
                title: '保存失败',
                message: response.data.data,
                type: 'error'
              })
            }
          });
        }
      })
    },
    recycleRestore(row, tag) {
      var module;
      switch (tag) {
        case 'task':
          module = 'EMAIL_SEND_TASK'

          break;
      }
      this.$confirm('确定还原吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_restore', {
          id: row.id,
          module: module
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.recycleBin(tag);
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    recycleDel(row, tag) {
      var module;
      switch (tag) {
        case 'task':
          module = 'EMAIL_SEND_TASK'
          break;
      }
      this.$confirm('此操作不可恢复, 确定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_delete', {
          id: row.id,
          module: module
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.recycleBin(tag);
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    changeTaskRecycleSize(val) {
      this.taskRecycleSize = val;
      this.recycleBin('task');
    },
    currentTaskRecycleChange(val) {
      this.taskRecycleCurrentPage = val;
      this.recycleBin('task');
    },
    recycleBin(tag) {
      switch (tag) {
        case 'task':
          this.vLoading = true;
          this.taskRecycleBin = true;
          this.$axios.get(`center/data/recycle_list`, {
            params: {
              size: this.taskRecycleSize,
              page: this.taskRecycleCurrentPage,
              module: 'EMAIL_SEND_TASK'
            }
          }).then((response) => {
            this.vLoading = false;
            if (response.data.code === 200) {
              this.taskRecycleBinData = response.data.data.data
              this.taskRecycleTotal = response.data.data.total
            }
          });
          break;
      }
    },
    concatenatedErrors(row) {
      return row.errors.join("<br>");
    },
    concatenatedSenders(row) {
      return row.sender_username.join("<br>");
    },
    concatenatedTurnModeProgress(row) {
      return row.progress.join("<br>");
    },
    concatenatedTurnModeSenders(row) {
      return row.turn_mode_senders.join("<br>");
    },
    concatenatedSentFrom(row) {
      return row.sent_from.join("<br>");
    },
    concatenatedTurnModeSent(row) {
      return row.turn_mode_sent.join("<br>");
    },
    concatenatedTurnModeRead(row) {
      return row.turn_mode_read.join("<br>");
    },
    concatenatedTurnModeUnRead(row) {
      return row.turn_mode_unread.join("<br>");
    },
    concatenatedTurnModeReadPercentage(row) {
      return row.turn_mode_read_percentage.join("<br>");
    },
    receiversSelected(val) {
      var obj = {}
      obj = this.receiversOptions.find(function (i) {
        return i.id === val
      });
      this.current_receiver_count = obj.detail_count
    },
    async showExportSendStats() {
      this.exportSendStatsVisible = true;
      this.exportSendStatsForm = {
        dates: null,
        user: [],
        product: ''
      }
      this.sLoading = true;
      this.screenSentData = [];
      await this.$axios.get(`basic/users/list?query=1`).then((response) => {
        this.sLoading = false;
        if (response.data.code === 200) {
          this.users = response.data.data
        } else {
          this.$notify({
            title: 'failed',
            message: '获取用户列表失败',
            type: 'warning'
          })
        }
      })
      // await this.$axios.get(`email/products`).then((response) => {
      //   if (response.data.code === 200) {
      //     this.products = response.data.data
      //   } else {
      //     this.$notify({
      //       title: 'failed',
      //       message: '获取产品列表失败',
      //       type: 'warning'
      //     })
      //   }
      // })
    },
    exportSendStats() {
      if (this.exportSendStatsForm.dates === null) {
        this.$message({
          type: 'error',
          message: '请选择时间跨度'
        })
        return false;
      }
      this.screenSentData = [];
      this.exportSendStatsLoading = true;
      this.$axios.post(`email/screen_sent_stats`, this.exportSendStatsForm).then((response) => {
        this.exportSendStatsLoading = false;
        if (response.data.code === 200) {
          this.screenSentData = response.data.data;
        }
      })
    },
    saveSendStats() {
      if (this.exportSendStatsForm.dates === null) {
        this.$message({
          type: 'error',
          message: '请选择时间跨度'
        })
        return false;
      }
      if (this.exportSendStatsForm.product === null) {
        this.$message({
          type: 'error',
          message: '请至少输入一个关键词'
        })
        return false;
      }
      this.save_btn_loading = true;
      this.save_btn_disabled = true;
      this.$axios.post(`email/save_sent_stats`, this.exportSendStatsForm).then((response) => {
        this.save_btn_loading = false;
        this.save_btn_disabled = false;
        if (response.data.code === 200) {
          window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + response.data.data;
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.emails-echarts {
  width: 100%;
  height: 80vh;
  overflow: auto;
}

.echarts-container {
  width: 30%;
  height: 350px;
  float: left;
  margin: 0 3% 30px 0;
  /* border: solid 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.echarts-title {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-left: solid 5px #2486D4;
  padding-left: 20px;
}

.echarts {
  width: 100%;
  height: 300px;
}

.echarts .el-row {
  margin-top: 25px;
}

.current_receiver_count {
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/Emails.vue